export default function ChevronRight({ size = 20, opacity = 0.5, strokeWidth = 1.5 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 15L12.5 10L7.5 5" stroke="white" strokeWidth={strokeWidth} strokeLinecap="square" strokeLinejoin="round" />
      <path
        d="M7.5 15L12.5 10L7.5 5"
        stroke="black"
        strokeOpacity={(opacity - 1) * -1}
        strokeWidth={strokeWidth}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}
